import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { HERO_MOCKUP } from "./data/content";
type MetaPixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
    requestIdleCallback?: (callback: () => void, options?: {
      timeout: number;
    }) => number;
  }
}
const FONTS_HREF = "https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800&family=Cormorant+Garamond:ital,wght@0,600;0,700;1,600;1,700&display=swap";
const SEO = {
  title: "MegaPack Árabe PRO · Resolvé todo tu año de Danza Árabe en 5 minutos",
  description: "6 contenidos completos y 5 bonos exclusivos para planificar, enseñar y renovar tus clases de Danza Árabe durante todo el año. Acceso inmediato · Pago único · Garantía de 7 días."
};
function appendLink(rel: string, href: string, extra: Record<string, string> = {}) {
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  Object.entries(extra).forEach(([key, value]) => link.setAttribute(key, value));
  document.head.appendChild(link);
  return link;
}
function setMeta(attr: "name" | "property", key: string, content: string) {
  let meta = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(attr, key);
    document.head.appendChild(meta);
  }
  meta.content = content;
}

/** Language, title and share metadata (the project has no editable index.html). */
function applySeo() {
  document.documentElement.lang = "es";
  document.title = SEO.title;
  setMeta("name", "description", SEO.description);
  setMeta("name", "theme-color", "#F8EFE6");
  setMeta("property", "og:type", "website");
  setMeta("property", "og:locale", "es_AR");
  setMeta("property", "og:title", SEO.title);
  setMeta("property", "og:description", SEO.description);
  setMeta("property", "og:image", HERO_MOCKUP);
  setMeta("property", "og:url", window.location.origin + window.location.pathname);
  setMeta("name", "twitter:card", "summary_large_image");
  setMeta("name", "twitter:title", SEO.title);
  setMeta("name", "twitter:description", SEO.description);
  setMeta("name", "twitter:image", HERO_MOCKUP);
  if (!document.head.querySelector('link[rel="canonical"]')) {
    appendLink("canonical", window.location.origin + window.location.pathname);
  }
}

/** Starts the LCP image download before React renders. */
function preloadHeroImage() {
  appendLink("preload", HERO_MOCKUP, {
    as: "image",
    fetchpriority: "high"
  });
}

/** Non-blocking web fonts: system fallback paints instantly, then swaps. */
function loadFonts() {
  appendLink("preconnect", "https://fonts.googleapis.com");
  appendLink("preconnect", "https://fonts.gstatic.com", {
    crossorigin: "anonymous"
  });
  const stylesheet = appendLink("stylesheet", FONTS_HREF, {
    media: "print"
  });
  stylesheet.addEventListener("load", () => {
    stylesheet.media = "all";
  }, {
    once: true
  });
}
function initializeMetaPixel() {
  if (window.fbq) return;
  const fbq: MetaPixelFunction = (...args) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
      return;
    }
    fbq.queue?.push(args);
  };
  fbq.queue = [];
  fbq.push = (...args) => fbq.queue?.push(args);
  fbq.loaded = true;
  fbq.version = "2.0";
  window.fbq = fbq;
  window._fbq = fbq;
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
  fbq("init", "1784852152931384");
  fbq("track", "PageView");
}

/**
 * Warms the code for lower sections so they are already cached when the
 * visitor scrolls or taps a CTA on a slow mobile connection.
 */
function prefetchSecondaryChunks() {
  void import("./components/sections/DeferredContent");
  void import("./components/sections/LateContent");
}

/** Runs work after the page has loaded and the main thread is idle. */
function afterLoadIdle(task: () => void, timeout: number) {
  const start = () => {
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(task, {
        timeout
      });
      return;
    }
    window.setTimeout(task, 1200);
  };
  if (document.readyState === "complete") start();else window.addEventListener("load", start, {
    once: true
  });
}
applySeo();
preloadHeroImage();
loadFonts();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-331" data-mp="c0y7t6xrasa9" />);
}
afterLoadIdle(initializeMetaPixel, 2500);
afterLoadIdle(prefetchSecondaryChunks, 4000);